export default {
  name: "payment-info",
  created() {
    document.getElementById("html").classList.add("hide");
  },
};
